export const colors = {
  black: '#000000',
  nav: '#161C24',
  paper2: '#212B36',
  paper3: '#303B46',
  blue: '#0178FF',
  blueDark: '#1C252E',
  gray: '#8D8D8D',
  grayLight: '#707070',
  green: '#2CCC70',
  orange: '#E89806',
  pink: '#FF65F9',
  purple: '#9964FA',
  purpleLight: '#B8A0D4',
  redLight: '#FFE9D5',
  red: '#FF5630',
  redDark: '#B71D18',
  white: '#FFFFFF',
  yellow: '#ECD24E',
  cyan: '#49DFC8',
  primary: '#00A76F',
  // GREEN COLORS
  lighter: '#C8FAD6',
  light: '#5BE49F',
  dark: '#007867',
  darker: '#004B50',
}
